import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import Columns from './columns';
import ColumnsService from '@/services/columns';
import UrlMixin from '@/components/query/url-mixin';

@Component
export default class Sort extends mixins<Columns, UrlMixin>(Columns, UrlMixin) {
  get columnSort() {
    const { orderBy, orderDir } =  this.columnSettings
    return { orderBy, orderDir }
  }

  sortIcon({ value }) {
    const { orderDir, orderBy } = this.columnSort
    return orderBy === value && orderDir === 'asc' ? 'fas fa-sort-down' : 'fas fa-sort-up'
  }
  
  get allNotSortableColumnsObject(){
      return this.getCustomMetrics(this.$route.name)?.sort_exclude.reduce((acc, item) => {
          acc[item] = true;
          return acc;
      }, {})
  }

  isDisplaySort(header) {
      return !this.allNotSortableColumnsObject[header?.value]
  }

  isActiveSort(header) {
    const { orderBy } = this.columnSort
    return orderBy === header.value
  }

  onChangeSort(header) {
    if(!this.isDisplaySort(header)) return;
    if(header.disableSortChange !== true) {
      let orderDir = 'desc'

      if (header.value === this.columnSort.orderBy) {
        orderDir = this.columnSort.orderDir === 'asc' ? 'desc' : 'asc'
      }

      this.$store.dispatch('patchOrder', { orderBy: header.value, orderDir: orderDir })
      
      // don't save in column settings if active report
      if(this.isReport()){
        this.bus.emit('reload-report');
      }else{
        this.$store.commit('loading', true);
  
        this.columnSettingsApi.updateColumnOrder({
          id:this.$store.state.report.activePreset,
          settings: [{
            context: ColumnsService.type,
            order: {
              orderBy: header.value,
              orderDir
            }
          }],
        })
          .then(() => {
            this.bus.emit('apply-filters');
          })
          .finally(() => this.$store.commit('loading', false))
      }
    }
  }
}
